import { primeIcon } from "../icon";

/** Padrões do Figma para o `Dialog` do Prime: sem arrastar nem redimensionar, X `times` 14 e 100vw abaixo de `md` (48rem). */
export const DIALOG_DEFAULTS = {
  draggable: false,
  resizable: false,
  dismissableMask: false,
  closeIcon: primeIcon("times", 14),
  breakpoints: { "48rem": "100vw" },
};
